import { render, staticRenderFns } from "./LeaveCodesList.vue?vue&type=template&id=2a562860&scoped=true&"
import script from "./LeaveCodesList.vue?vue&type=script&lang=js&"
export * from "./LeaveCodesList.vue?vue&type=script&lang=js&"
import style0 from "./LeaveCodesList.vue?vue&type=style&index=0&id=2a562860&lang=scss&scoped=true&"
import style1 from "./LeaveCodesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a562860",
  null
  
)

export default component.exports